<template>
  <div class="remittance-table-wrap">
    <el-table
      v-loading="loading"
      :data="report"
      stripe
      size="medium"
      element-loading-text="Loading..."
      empty-text="No posted ledgers available"
      class="remittance-table"
      style="width: 100%;">
      <el-table-column
        prop="year"
        label="Year"
        width="110"
        align="center"/>
      <el-table-column
        label="Month"
        min-width="150">
        <template slot-scope="scope">
          <span class="month-name">{{ formatMonth(scope.row.month) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Deduction"
        min-width="260">
        <template slot-scope="scope">
          <select-deduction
            :deduct="deduction"
            :key="sel"
            class="deduction-field"
            size="small"
            @setDeduction="$emit('set-deduction', $event, scope.$index)"/>
        </template>
      </el-table-column>
      <el-table-column
        label="Generate"
        width="170"
        align="center">
        <template slot-scope="scope">
          <el-tooltip content="Generate remittance file" placement="top">
            <el-button
              :disabled="!hasSelectedDeduction(scope.$index)"
              type="primary"
              size="small"
              class="generate-button"
              @click="$emit('download', 'payroll', 'first', scope.row, scope.$index)">
              <i class="far fa-file-excel"/>
              Generate
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="remittance-pagination">
      <el-pagination
        :page-size="meta.per_page"
        :pager-count="7"
        :total="meta.total"
        :current-page.sync="currentPage"
        layout="total, prev, pager, next"
        @current-change="$emit('page-change')"/>
    </div>
  </div>
</template>

<script>
import SelectDeduction from '@/views/layout/components/SelectDeduction'

export default {
  name: 'SingleRemittanceTab',
  components: {
    SelectDeduction
  },
  props: {
    deduction: {
      default: null,
      type: Object
    },
    loading: {
      default: false,
      type: Boolean
    },
    meta: {
      default: () => ({ page: 1 }),
      type: Object
    },
    report: {
      default: () => [],
      type: Array
    },
    selectedDeductions: {
      default: () => ({}),
      type: Object
    },
    sel: {
      default: 0,
      type: Number
    },
    monthList: {
      default: () => [],
      type: Array
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.meta.page
      },
      set(value) {
        this.$emit('update-page', value)
      }
    }
  },
  methods: {
    formatMonth(month) {
      return this.monthList[(month - 1)] || 'UNKNOWN'
    },
    hasSelectedDeduction(index) {
      return !!this.selectedDeductions[index]
    }
  }
}
</script>
